import React, { useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "./styles.css";
import { BlurWrapper } from "../../Utils/CustomComponent";

const UseFormPhoneNumberInput = ({
  title,
  field,
  register,
  setValue,
  watch,
  error,
  disable,
  blur = false,
}) => {
  useEffect(() => {
    register(field);
  }, [field, register]);

  const labelClassName = `phoneNumberLabel ${error ? "error" : "normal"}`;

  const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber?.length === 10) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
        3,
        6
      )}-${phoneNumber.slice(6)}`;
    } else {
      return phoneNumber;
    }
  };

  return (
    <div className="form-group position-relative">
      {/* <style>
        {`
          .form-control.phoneNumber + div:before {
            content: '${title}';
            position: absolute;
            top: -10px;
            left: 15px;
            display: block;
            background: white;
            padding: 0 5px;
            font-size: 13px;
            white-space: nowrap;
             color: ${error ? '#dc3545' : 'darkgrey'};
          }
          .react-tel-input .form-control.phoneNumber {
            width: 100%;
          }
          .react-tel-input .form-control.phoneNumber.custom-is-invalid{
            border-color: #dc3545 !important;
            padding-right: calc(1.5em + 0.75rem) !important;
            background-image: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e') !important;
            background-repeat: no-repeat !important;
            background-position: right calc(0.375em + 0.1875rem) center !important;
            background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
        }}
        `}
      </style> */}
      <div className={labelClassName} data-title={title}></div>
      <BlurWrapper>
        <PhoneInput
          country="us"
          onlyCountries={["us"]}
          value={watch(field)}
          onChange={(phone) => setValue(field, formatPhoneNumber(phone))}
          inputProps={{
            name: field,
            id: field,
            disabled: disable,
            className: `form-control phoneNumber ${
              watch(field) ? "" : "fw-light"
            } ${error ? "custom-is-invalid" : ""}`,
          }}
          disableCountryCode={true}
          placeholder="(702) 123-4567"
        />
      </BlurWrapper>

      {error && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default UseFormPhoneNumberInput;
